import { emailAddressSchema } from '../../models/schemas/email-address.schema';

export const isValidEmail = (emailAddress: string): boolean => emailAddressSchema.safeParse(emailAddress).success;
